module.exports = __webpack_public_path__ + "static/media/dental_product_two.d323ae0b.png";